import { useState } from "react";
import BackDrop from "../../../components/ui/BackDrop";
import { fileUploadIcon } from "../../../assetData/icons";
import Loader from "../../../components/ui/Loader";

import { closeIcon } from "../../../assetData/icons";
import MirageLoader from "../../../components/ui/pageLoader/MirageLoader";
const CorporateActionMasterImport = ({
  handleImportCorpAction,
  buttonConfig,
  isButtonClicked,
}) => {
  const closeHandler = buttonConfig.closeImportModel;

  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleFileUpload = async () => {
    if (selectedFile) {
      const formData = new FormData();
      formData.append("file", selectedFile);
      const res = await handleImportCorpAction(formData);
      if (res) {
        closeHandler();
      }
    }
  };

  const onClose = () => {
    closeHandler();
  };

  return (
    <>
      {isButtonClicked && <Loader />}
      <div className="fixed left-1/2 top-1/2 z-20 mx-auto min-h-[300px] max-w-[1200px] -translate-x-1/2 -translate-y-1/2 rounded bg-white p-8 max-md:w-full md:w-[500px]">
        <h2 className="pb-4 text-2xl font-bold text-neutral-800">
          Import Corporate Action Data{" "}
        </h2>

        <button
          type="button"
          className="absolute top-8 max-md:right-2 md:right-8"
          onClick={onClose}
        >
          <img src={closeIcon} />
        </button>

        <div className="mt-8 flex gap-2 ">
          <div className="w-full space-y-4">
            <label className="text-[#000]">Document to upload</label>
            <div className="relative overflow-hidden rounded-lg max-md:w-full md:w-full">
              <input
                type="file"
                className="custom-doc-uploader  bg-[#FAFAFA] text-neutral-600"
                onChange={handleFileChange}
              />
              <img
                src={fileUploadIcon}
                className="absolute left-4 top-1/2 z-10 -translate-y-1/2"
              />
            </div>

            <div className="flex items-center justify-between gap-2  max-sm:[&>button]:w-full sm:[&>button]:w-1/2">
              <button
                type="submit"
                disabled={isButtonClicked}
                className={` ${
                  isButtonClicked ? "opacity-[70%]" : ""
                } mt-8 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange  py-2 font-semibold text-white`}
                onClick={handleFileUpload}
              >
                {isButtonClicked ? <MirageLoader /> : "IMPORT"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <BackDrop closeHandler={closeHandler} />
    </>
  );
};

export default CorporateActionMasterImport;
